import { versioneInSituStore } from '../VersioneInSitu/store/VersioneInSitu.store';
import moment from 'moment';
import { areaOmogeneaStore } from '../AreeOmogenee/store/areaOmogenera.store';
import { domainStore } from '../domains';
import { printerHelper } from '../printer';
import { usersStore } from '../Utenti/store/users.store';

export async function exportForm(source: server.areaBoscoDaSeme, type: printer.type = printer.type.pdf): Promise<void> {
    let utenteCreatore = ["-- nessun creatore --"];
    let utentiRilevatori: string[] = ["-- nessun rilevatore --"];
    const users = await usersStore.getters.getAll();

    if (source.userId) {
        const user = users.find(f => f.id.toLowerCase() === source.userId.toLowerCase());
        if (user) utenteCreatore = [`${user.firstName} ${user.lastName}`];
    }

    if ((source.utentiRilevatori || []).length > 0) {
        utentiRilevatori = users.filter(f => source.utentiRilevatori.map(m => m.toLowerCase()).indexOf(f.id.toLowerCase()) !== -1)
            .map((m) => `${m.firstName} ${m.lastName}`)
            .sort((a, b) => a.localeCompare(b));
    }

    const printObj = [
        {
            header: "Dati Generali",
            data: {
                'Anno censimento': (await versioneInSituStore.getters.get(source.versioneId)).alias,
                'Denominazione Area': source.nome ? source.nome : '',
                'Area omogenea relazionata': (await areaOmogeneaStore.getters.get(source.areaOmogeneaId)).nome,
                'Proprietà': source.proprieta ? source.proprieta : '',
            }
        }, {
            header: "Altro",
            data: {
                'Note': source.note ? source.note:null,
                'Data rilievo': source.data ? moment(source.data).format("DD-MM-YYYY") : '',
                'Utente creatore dell\'area': utenteCreatore,
                'Rilevatori in campo': utentiRilevatori
            }
        }, {
            header: "Dati catastali",
            data: {
                'Dati catastali': source.datiCatastali ? source.datiCatastali : '',
            }
        }, {
            header: "Dati geografici",
            data: {
                'Denominazione provenienza': source.provenienza ? source.provenienza : '',
                'Località': source.localita ? source.localita : '',
                'Bacino idrografico': source.bacinoIdrografico ? source.bacinoIdrografico : '',
                'Provincia': source.provincia ? source.provincia : '',
                'Comune': source.comune ? source.comune : '',
                'Stazione CCF': source.stazioneCCF ? source.stazioneCCF : '',
                'Riferimenti cartografici': source.riferimentiCartografici ? source.riferimentiCartografici : '',
                'Superficie Bosco': source.superficieBosco || source.superficieBosco==0 ? source.superficieBosco + ' m2' : '',
                'Superficie Area': source.area || source.area==0 ? source.area.toFixed(2) + ' m2' : '',
                'Altitudine': source.altitudine || source.altitudine==0 ? source.altitudine.toFixed(1) + ' m' : '',
                'Altezza dal fondovalle': source.altezzaFondovalle || source.altezzaFondovalle==0 ? source.altezzaFondovalle.toFixed(1) + ' m' : '',
                'Giacitura': source.giacitura != null && source.giacitura != undefined ? (await domainStore.getters.giacitura(source.giacitura))?.label : '',
                'Esposizione': source.esposizione != null && source.esposizione != undefined ? (await domainStore.getters.esposizione(source.esposizione))?.label : '',
                'Pietrosità': source.pietrosita != null && source.pietrosita != undefined ? (await domainStore.getters.pietrositaByValue(source.pietrosita))?.label : '',
                'Pendenza': source.pendenza || source.pendenza==0 ? source.pendenza : '',
                'Aff. rocciosi': source.rocciosi || source.rocciosi==0 ? source.rocciosi : '',
                'Note informazioni geografiche': source.altreInformazioniGeografiche ? source.altreInformazioniGeografiche : null,
            }
        }, {
            header: "Dati climatici",
            data: {
                'Stazione termometrica di riferimento': source.stazioneTermometrica ? source.stazioneTermometrica : '',
                'T media annua': source.temperaturaAnnuaMedia || source.temperaturaAnnuaMedia==0 ? source.temperaturaAnnuaMedia + ' °C' : '',
                'T media mese più caldo': source.temperaturaMensileMeseCaldoMedia || source.temperaturaMensileMeseCaldoMedia==0 ? source.temperaturaMensileMeseCaldoMedia + ' °C' : '',
                'T media mese più freddo': source.temperaturaMensileMeseFreddoMedia || source.temperaturaMensileMeseFreddoMedia==0 ? source.temperaturaMensileMeseFreddoMedia + ' °C' : '',
                'T max assoluta': source.temperaturaAssolutaMax || source.temperaturaAssolutaMax==0 ? source.temperaturaAssolutaMax + ' °C' : '',
                'T min assoluta': source.temperaturaAssolutaMin || source.temperaturaAssolutaMin==0 ? source.temperaturaAssolutaMin + ' °C' : '',
                'Stazione pluviometrica di riferimento': source.stazionePluviometrica ? source.stazionePluviometrica : '',
                'Precipitazioni annue': source.precipitazioniAnnue || source.precipitazioniAnnue==0 ? source.precipitazioniAnnue + ' mm' : '',
                'Precipitazioni estive [Giu-Set]': source.precipitazioniEstive || source.precipitazioniEstive==0 ? source.precipitazioniEstive + ' mm' : '',
                'Venti dominanti': source.ventiDominanti ? source.ventiDominanti : '',
                'N° giorni piovosi': source.numeroGiorniPiovosi || source.numeroGiorniPiovosi==0 ? source.numeroGiorniPiovosi : '',
                'N° giorni piovosi estivi': source.numeroGiorniPiovosiEstivi || source.numeroGiorniPiovosiEstivi==0 ? source.numeroGiorniPiovosiEstivi : '',
                'Altre informazioni climatiche (neve, grandine, gealte, nebbie...)': source.altreInformazioniClimatiche ? source.altreInformazioniClimatiche : '',
            }
        }, {
            header: "Dati geopedologici",
            data: {
                'Substrato Pedogenetico': source.substratoPedogenetico != null && source.substratoPedogenetico != undefined ? (await domainStore.getters.substratoPetrogenico(source.substratoPedogenetico))?.label : '',
                'Profondità terreno': source.profonditaTerreno || source.profonditaTerreno==0 ? source.profonditaTerreno + ' cm' : '',
                'Orizzonti presenti': source.orizzontiPresenti ? source.orizzontiPresenti : '',
                'Lettiera': source.lettiera != null && source.lettiera != undefined ? (await domainStore.getters.lettiera(source.lettiera))?.label : '',
                'Note geopedologia': source.altreInformazioniGeopedologiche ? source.altreInformazioniGeopedologiche : null,
            }
        }, {
            header: "Dati del popolamento forestale",
            data: {
                'Origine': source.originePopolamentoForestale != null && source.originePopolamentoForestale != undefined ? (await domainStore.getters.originePopolamentoForestale(source.originePopolamentoForestale))?.label : '',
                'Governo': source.governo != null && source.governo != undefined ? (await domainStore.getters.governo(source.governo))?.label : '',
                'Trattamento': source.trattamento != null && source.trattamento != undefined ? (await domainStore.getters.trattamento(source.trattamento))?.label : '',
                'Stadio evolutivo': source.stadioEvolutivo ? source.stadioEvolutivo : '',
                'Età': source.eta ? source.eta : '',
                'Struttura Verticale': source.strutturaVerticale != null && source.strutturaVerticale != undefined ? (await domainStore.getters.strutturaVerticale(source.strutturaVerticale))?.label : '',
                'Struttura Orizzontale Tessitura': source.strutturaOrizzontaleTessitura != null && source.strutturaOrizzontaleTessitura != undefined ? (await domainStore.getters.strutturaOrizzontale(source.strutturaOrizzontaleTessitura))?.label : '',
                'Note struttura forestale': source.altreInformazioniPopolamentoForestale ? source.altreInformazioniPopolamentoForestale : null,
            }
        }, {
            header: "Dati vegetazionali",
            data: {
                'Composizione Specifica': source.specificaComposizioneVegetazionaleId != null && source.specificaComposizioneVegetazionaleId != undefined ? (await domainStore.getters.composizioneVegetazionale(source.specificaComposizioneVegetazionaleId))?.label : '',
                'Specie arboree': source.specieArboree != null && source.specieArboree.length > 0 ? (await domainStore.getters.specieArboree()).filter((f) => source.specieArboree.includes(f.id)).map((m) => m?.label).join(", ") : '',
                'Specie arbustiva': source.specieArbustive ? source.specieArbustive : '',
                'Specie erbacee': source.specieErbacee ? source.specieErbacee : '',
                'Note vegetazione': source.altreInformazioniVegetazionali ? source.altreInformazioniVegetazionali : null,
            }
        }, {
            header: "Informazioni per la certificazione",
            data: {
                'Specie di interesse': source.specieDiInteresse != null && source.specieDiInteresse.length > 0 ? (await domainStore.getters.specieArboree()).filter((f) => source.specieDiInteresse.includes(f.id)).map((m) => m?.label).join(", ") : '',
                'Origine Materiale Selezionato ': source.origineMaterialeSelezionato != null && source.origineMaterialeSelezionato != undefined ? (await domainStore.getters.origineMaterialeSelezionato(source.origineMaterialeSelezionato))?.label : '',
                'Isolamento': source.isolamento ? source.isolamento : '',
                'Entità della popolazione': source.popolazione ? source.popolazione : '',
                'Età e sviluppo': source.etaESviluppo ? source.etaESviluppo : '',
                'Omogeneità': source.omogeneita ? source.omogeneita : '',
                'Adeguetezza': source.adeguatezza ? source.adeguatezza : '',
                'Stato sanitario': source.statoSanitario ? source.statoSanitario : '',
                'Qualità del legno': source.qualitaLegno ? source.qualitaLegno : '',
                'Forma o portamento': source.formaPortamento ? source.formaPortamento : '',
            }
        }, {
            header: "Altre informazioni di carattere generale",
            data: {
                'Accessibilità': source.accessibilita ? source.accessibilita : '',
                'Proprietà': source.proprietaCarattereGenerale ? source.proprietaCarattereGenerale : '',
            }
        }
    ] as printer.group[];
    printerHelper.print(type, source.nome, 'Area Bosco da Seme', printObj);
}